import React, { useRef, useState, useEffect, Fragment } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import classes from './styles.module.css';

function ProjectSearchList({
    projects = [],
    onProjectsChange,
    projectsList = [],
    onEditPermissions = null,
    accountId = null,
    globalPermissionsEnabled = false,
}) {
    const intl = useIntl();
    const [searchTerm, setSearchTerm] = useState('');
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const containerRef = useRef(null);
    const inputRef = useRef(null);

    const safeLowerCase = (str) => {
        return (typeof str === 'string' ? str : '').toLowerCase();
    };

    const filteredProjects = projectsList.filter((project) => {
        const displayName = (project && project.displayName) || '';
        const name = (project && project.name) || '';
        const uuid = (project && project.uuid) || '';
        const lowerSearch = safeLowerCase(searchTerm);

        return (
            safeLowerCase(displayName).includes(lowerSearch) ||
            safeLowerCase(name).includes(lowerSearch) ||
            safeLowerCase(uuid).includes(lowerSearch)
        );
    });

    function addProject(uuid) {
        const project = projectsList.find((p) => p && p.uuid === uuid);
        if (project && !projects.find((p) => p && p.uuid === project.uuid)) {
            onProjectsChange([...projects, project]);
            setSearchTerm('');
            setIsDropdownOpen(false);
            if (inputRef.current) {
                inputRef.current.focus();
            }
        }
    }

    function removeProject(uuid) {
        onProjectsChange(projects.filter((p) => p && p.uuid !== uuid));
    }

    useEffect(() => {
        function handleClickOutside(event) {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className={classes.Wrapper} ref={containerRef}>
            <div className={classes.SearchContainer}>
                <input
                    ref={inputRef}
                    type="text"
                    className={classes.SearchInput}
                    placeholder={intl.formatMessage({ id: 'ProjectSearchList.placeholder' })}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    onFocus={() => setIsDropdownOpen(true)}
                />
                {isDropdownOpen && filteredProjects.length > 0 && (
                    <ul className={classes.DropdownList}>
                        {filteredProjects
                            .filter((p) => p && !projects.find((selected) => selected && selected.uuid === p.uuid))
                            .map((project) => {
                                const displayName = (project && project.displayName) || (project && project.name) || '';
                                return (
                                    <li
                                        key={project && project.uuid}
                                        className={classes.DropdownItem}
                                        onClick={() => addProject(project && project.uuid)}
                                    >
                                        <div className={classes.DropdownItemTitle}>{displayName}</div>
                                        <div className={classes.DropdownItemUuid}>
                                            {(project && project.uuid) || ''}
                                        </div>
                                    </li>
                                );
                            })}
                    </ul>
                )}
                {isDropdownOpen && filteredProjects.length === 0 && searchTerm && (
                    <div className={classes.DropdownEmpty}>
                        <FormattedMessage id="ProjectSearchList.empty" defaultMessage="Ничего не найдено" />
                    </div>
                )}
            </div>

            {projects.length > 0 && (
                <Fragment>
                    <h5 className={classes.SelectedTitle}>
                        <FormattedMessage id="ProjectSearchList.selected.title" defaultMessage="Выбранные проекты" />
                    </h5>
                    <ul className={classes.SelectedList}>
                        {projects.map((p) => {
                            const displayName = (p && p.displayName) || (p && p.name) || '';
                            return (
                                <li key={p && p.uuid} className={classes.SelectedItem}>
                                    <span>{displayName}</span>
                                    <div className={classes.ItemActions}>
                                        {onEditPermissions && accountId && (
                                            <button
                                                className={
                                                    globalPermissionsEnabled
                                                        ? classes.PermissionsBtnLocked
                                                        : classes.PermissionsBtn
                                                }
                                                onClick={() => onEditPermissions(p, accountId)}
                                                title={
                                                    globalPermissionsEnabled
                                                        ? 'Global permissions are enabled'
                                                        : intl.formatMessage({
                                                              id: 'ProjectSearchList.permissions.title',
                                                              defaultMessage: 'Настроить права',
                                                          })
                                                }
                                            >
                                                {globalPermissionsEnabled ? (
                                                    '\uD83D\uDD12 Permissions'
                                                ) : (
                                                    <FormattedMessage
                                                        id="ProjectSearchList.permissions.btn"
                                                    defaultMessage="Права"
                                                    />
                                                )}
                                            </button>
                                        )}
                                        <button
                                            className={classes.RemoveBtn}
                                            onClick={() => removeProject(p && p.uuid)}
                                            aria-label={intl.formatMessage(
                                                { id: 'ProjectSearchList.remove.aria' },
                                                { name: displayName }
                                            )}
                                        >
                                            X
                                        </button>
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                </Fragment>
            )}
        </div>
    );
}

export default ProjectSearchList;



// WEBPACK FOOTER //
// ./src/Components/ComponentsOfAdministrator/ProjectSearchList/index.js